import Vue from 'vue';
let vm = new Vue();
import axios from 'axios'
import qs from 'qs';

import Config from './config'
import Utils from './utils'
import User from './user'
import Router from '../router'

import md5 from 'js-md5';
import Moment from 'moment';

// export default {
const http = {
    test(){
        vm.$toast.loading({
            message: '加载中...',
            forbidClick: true,
        });
    },
    post:function(obj){
        let _temp_data = JSON.parse(JSON.stringify(obj.data));

        // console.log(_temp_data);

        if(obj.url === 'Bids/detail'){
            delete obj.data.id;
        }

        let _datas = Utils.isUndefined(obj.data) ? null : qs.stringify(obj.data);
        let _showLoad = Utils.isUndefined(obj.showLoad) ? false : obj.showLoad;
        let _heads = {'Content-Type':'application/x-www-form-urlencoded','Accept': 'application/json'};

        let loadingInstance = null;
        if(_showLoad) {
            // loadingInstance = vm.$loading({lock:true});
            vm.$toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
        }

        let _token = User.getToken();
        if(_token){
            _heads.Authorization = _token;
        }

        let _time = Moment().unix();

        let _secret = md5(Config.secret + _time.toString());

        _heads.secret = _secret;
        _heads.timestamp = _time;

        if(obj.url === 'Bids/detail'){
            obj.url = obj.url + '?id='+ _temp_data.id;
        }

        // console.log(_heads);
        axios({
            headers:_heads,
            method: 'post',
            url: obj.url.indexOf('http') >= 0 ? obj.url : Config.apiUrl+obj.url,
            data:_datas ? _datas : null
        }).then(function(res){
            if(_showLoad) {
                vm.$toast.clear();
            }
            if(res.data.code === 0){
                if(obj.success){
                    obj.success(res.data.result);
                }
            }else{
                if(res.data.code === -1004){
                    vm.$toast({
                        message: '登录信息已失效，请重新登录',
                        position: 'top',
                    });
                    Utils.localClear();
                    Router.replace({path:'/'});
                }else {
                    if (obj.fail) {
                        obj.fail(res.data);
                    } else {
                        vm.$toast({message: res.data.msg, position: 'top'});
                    }
                }
            }
        },function(error){
            vm.$toast({message: error, position: 'top'});
        }).catch(function (error) {
            console.log(error);
            vm.$toast({message: error, position: 'top'});
            if(_showLoad) {
                vm.$toast.clear();
            }
        })
        // 埋点
        if(_token) {
          let base_url = Config.baseUrl
          axios({
            headers:_heads,
            method: 'post',
            url: `${base_url}/Service/common/dailyAccessRecord/recordAccess`,
          })
        }
    },
    upLoad:function(file){
        let config = {
            //添加请求头
            headers: { "Content-Type": "multipart/form-data" },
            //添加上传进度监听事件
            onUploadProgress: e => {
                var completeProgress = ((e.loaded / e.total * 100) | 0) + "%";
                this.progress = completeProgress;
            }
        };

        let param = new FormData();
        param.append("imageFile", file);
        console.log(param.get("imageFile"));

        axios.post('http://miiheapi/user/up', param, config).then(
            function (response)
            { console.log(response); })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export default http;
